import { getVapidPublicKey, registerDevice } from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const requestNotificationPermission = async () => {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.error('Push notifications not supported');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return null;
    }

    // Register service worker
    const registration = await navigator.serviceWorker.register('/service-worker.js');
    await navigator.serviceWorker.ready;

    // Get VAPID public key from server
    const vapidResponse = await getVapidPublicKey();
    const vapidPublicKey = vapidResponse.data.publicKey;

    // Convert VAPID key for subscription
    const convertedVapidKey = urlBase64ToUint8Array(
      vapidPublicKey
        .replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----/g, '')
        .replace(/\n/g, '')
    );

    // Subscribe to push notifications
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedVapidKey
    });

    // Register subscription with server
    await registerDevice(subscription.toJSON());

    return subscription;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return null;
  }
};

export const setupNotificationListener = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'push-notification') {
        console.log('Received push notification:', event.data);
      }
    });
  }
};
